module.exports = __webpack_public_path__ + "img/MobileHeaderComponent@4x.bc0c798e.png";